export default "__VITE_ASSET__Dy6ke0t5__"